import { Card } from "@/components/ui/card";
import { MapPin, DollarSign, Building, TrendingUp } from "lucide-react";

interface PortfolioStatsProps {
  totalJobs: number;
  totalValue: number;
  citiesCovered: number;
}

export function PortfolioStats({ totalJobs, totalValue, citiesCovered }: PortfolioStatsProps) {
  const stats = [
    {
      label: "Completed Projects",
      value: totalJobs.toString(),
      icon: MapPin,
      color: "from-blue-500 to-blue-600",
    },
    {
      label: "Total Portfolio Value",
      value: `$${(totalValue / 1000).toFixed(0)}K`,
      icon: DollarSign,
      color: "from-green-500 to-green-600",
    },
    {
      label: "Cities Covered",
      value: citiesCovered.toString(),
      icon: Building,
      color: "from-purple-500 to-purple-600",
    },
    {
      label: "Avg. Project Value",
      value: totalJobs > 0 ? `$${Math.round(totalValue / totalJobs / 1000)}K` : "$0",
      icon: TrendingUp,
      color: "from-orange-500 to-orange-600",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <Card key={stat.label} className="p-4 hover:shadow-md transition-shadow">
          <div className="flex items-center gap-3">
            <div className={`p-2.5 rounded-lg bg-gradient-to-br ${stat.color}`}>
              <stat.icon className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-2xl font-bold">{stat.value}</p>
              <p className="text-xs text-muted-foreground">{stat.label}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
